import React, { useEffect, useState } from 'react'
import { CCard, CCardBody, CCardTitle, CModal, CModalHeader, CModalBody, CModalFooter, CCardSubtitle, CCardText, CModalTitle, CRow, CCol, CFormInput, CDropdown, CDropdownMenu, CDropdownToggle, CDropdownItem, CFormCheck, CButton, CFormTextarea, CFormSelect } from '@coreui/react';
import CookieFunctions from '../functions/CookieFunctions';
import { toast } from 'react-toastify';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import '../styles/TimeOff.css';

import { timeOffNames } from '../Constants';

export default function TimeOffRequest() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [halfDay, setHalfDay] = useState(false);
    const [comments, setComments] = useState("");
    const [errors, setErrors] = useState([])
    const [weekend, setWeekend] = useState(false);
    const [loading, setLoading] = useState(false);
    const [location, setLocation] = useState("");
    const driverType = CookieFunctions.getDriverType();
    const country = CookieFunctions.getCountry();
    const [vacationPay, setVacationPay] = useState('No');
    const [confirmationModalVisible, setConfirmationModalVisible] = useState(false);
    const [requestData, setRequestData] = useState(null);
    const [lieuDays, setLieuDays] = useState(0);
    const [lieuModalVisible, setLieuModalVisible] = useState(false);

    const [type, setType] = useState(Object.keys(timeOffNames[driverType][country])[0]);
    const [workWeek, setWorkWeek] = useState('Monday - Friday');
    const [other, setOther] = useState("");

    const handleWorkWeek = (e) => {
        setWorkWeek(e.target.value);
    };
    const handleVacationPay = (event) => {
        setVacationPay(event.target.value);
    };

    function onSubmit() {
        setLoading(true)
        setErrors([])

        var valid = validateData()

        if (valid.length !== 0) {
            setErrors(valid)
            setLoading(false)
            return
        }
        let requestedDays = halfDay ? 0.5 : (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;
        if (type === "TOVAC" && country === "CAN" && lieuDays > 0 && !halfDay && requestedDays > 1) {
            setLieuModalVisible(true);
            setLoading(false);
            return;
        }
        var newStartDate = startDate;
        var newEndDate = endDate;

        if (halfDay) {
            newStartDate = addTime(startDate, document.getElementById("startTime").value)
            newEndDate = addTime(startDate, document.getElementById("endTime").value)
        }

        var newStartDateString = (newStartDate.getMonth() + 1) + "/" + newStartDate.getDate() + "/" + newStartDate.getFullYear() + " " + newStartDate.getHours() + ":" + newStartDate.getMinutes() + ":" + newStartDate.getSeconds();
        var newEndDateString = (newEndDate.getMonth() + 1) + "/" + newEndDate.getDate() + "/" + newEndDate.getFullYear() + " " + newEndDate.getHours() + ":" + newEndDate.getMinutes() + ":" + newEndDate.getSeconds();

        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();

        formData.append("timeOffType", type)
        formData.append("startDate", newStartDateString)
        formData.append("endDate", newEndDateString)
        formData.append("halfDay", halfDay)
        formData.append("comments", comments)
        formData.append("weekend", weekend)
        formData.append("location", location)
        formData.append("confirmRequest", false);

        if (country === "CAN") {
            if (type === "TOVAC") {
                if (workWeek === "other") {
                    formData.append("workWeek", other)
                    formData.append("vacationPay", vacationPay)
                } else {
                    formData.append("workWeek", workWeek)
                    formData.append("vacationPay", vacationPay)
                }
            } else if (type === "TOUNP") {
                formData.append("workWeek", null)
                formData.append("vacationPay", null)
            }
            else {
                if (workWeek === "other") {
                    formData.append("workWeek", other)
                    formData.append("vacationPay", null)
                } else {
                    formData.append("workWeek", workWeek)
                    formData.append("vacationPay", null)
                }
            }
        } else {
            formData.append("workWeek", null)
            formData.append("vacationPay", null)
        }

        fetch("/api/drivers/requestTimeOff",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            setLoading(false)
            if (res.ok) {
                toast.success("A request has been submitted!", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored"
                });
                clearForm()
                fetchLieuDays();
            } else if (res.status === 400) {
                return res.text()
            }
        }).then((data) => {
            if (data === "You are requesting more days than you have accrued. Do you still want to submit the request?") {
                setRequestData(formData);
                setConfirmationModalVisible(true);
            } else if (data && data.startsWith("{")) {
                setErrors(["Unable to process your request. Please try again."])
            } else {
                setErrors([data])
            }
        })
    }

    function confirmRequest() {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        requestData.set("confirmRequest", true);

        fetch("/api/drivers/requestTimeOff",
            {
                headers: myHeaders,
                method: 'POST',
                body: requestData
            }
        ).then((res) => {
            setLoading(false);
            if (res.ok) {
                toast.success("A request has been submitted!", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored"
                });
                clearForm();
            } else if (res.status === 400) {
                return res.text();
            }
        }).then((data) => {
            if (data && data.startsWith("{")) {
                setErrors(["Unable to process your request. Please try again."]);
            } else {
                setErrors([data]);
            }
        })
        setConfirmationModalVisible(false);
    }
    function validateData() {
        var errors = []

        var startTime = document.getElementById("startTime") ? document.getElementById("startTime").value : null;
        var endTime = document.getElementById("endTime") ? document.getElementById("endTime").value : null;

        // null checks
        if (type === null) {
            errors.push("Time off type is requred")
        } else if (startDate === null || endDate === null) {
            errors.push("Start and end date are required")
        } else if (halfDay === true && (startTime === null || endTime === null)) {
            errors.push("Start and end time are required when requesting a half day")
        }

        if (errors.length > 0) {
            return errors
        }

        // data validation
        if (startDate > endDate) {
            errors.push("End date must be the same or after start date")
        } else if (startDate.toDateString() !== endDate.toDateString() && halfDay === true) {
            errors.push("Start and end date must be the same to take a half day")
        } else if (halfDay === true && (startTime === "" || endTime === "")) {
            errors.push("Start and end time are required for half day")
        } else if (halfDay === true) {
            if (!getTimeDifference(document.getElementById("startTime").value, document.getElementById("endTime").value)) {
                errors.push("Start and end times must be exactly 4 hours apart")
            }
        } else if (type === "TOPER" && comments === "") {
            errors.push("Comment with a reason is required when requesting personal leave")
        } else if (workWeek === "other" && other === "" && country === "CAN" && type !== "TOUNP") {
            errors.push("Please specify your workweek")
        }

        return errors

    }

    function getTimeDifference(time1, time2) {
        const parseTime = time => {
            const [hours, minutes, ampm] = time.split(/[:\s]/);
            return { hours: parseInt(hours, 10), minutes: parseInt(minutes, 10), ampm };
        };

        const { hours: hours1, minutes: minutes1, ampm: ampm1 } = parseTime(time1);
        const { hours: hours2, minutes: minutes2, ampm: ampm2 } = parseTime(time2);

        // Convert times to 24-hour format for easier calculation
        const convertTo24HourFormat = ({ hours, ampm }) => {
            if (ampm.toLowerCase() === 'pm' && hours !== 12) {
                return hours + 12;
            } else if (ampm.toLowerCase() === 'am' && hours === 12) {
                return 0;
            }
            return hours;
        };

        const timeInMinutes1 = convertTo24HourFormat({ hours: hours1, ampm: ampm1 }) * 60 + minutes1;
        const timeInMinutes2 = convertTo24HourFormat({ hours: hours2, ampm: ampm2 }) * 60 + minutes2;

        // Calculate time difference in minutes
        const timeDifferenceInMinutes = Math.abs(timeInMinutes2 - timeInMinutes1);

        // Convert minutes to hours and remaining minutes
        const hoursDifference = Math.floor(timeDifferenceInMinutes / 60);
        const minutesDifference = timeDifferenceInMinutes % 60;

        return (hoursDifference === 4 && minutesDifference === 0)
    }

    function addTime(date, time) {
        var t1 = time.split(" ")
        var ampm = t1[1] === "am" ? 0 : 12
        var HoursMins = t1[0].split(":")
        var hours = parseInt(HoursMins[0]) + ampm
        var mins = parseInt(HoursMins[1])

        var newDate = date.setHours(hours, mins)

        return new Date(newDate)
    }

    function clearForm() {
        setStartDate(null)
        setEndDate(null)
        setHalfDay(false)
        setComments("")
        setLocation("")
        setOther("")
    }

    useEffect(() => {
        if ((startDate === null || endDate === null) ? false : startDate.toDateString() !== endDate.toDateString()) {
            setHalfDay(false)
        }
        if (startDate > endDate) {
            setEndDate(startDate)
        }
    }, [startDate, endDate])

    useEffect(() => {
        if (type === "TOUNP") {
            setWeekend(false)
        }

    }, [type])

    function fetchLieuDays() {
        fetch("/api/drivers/checkLieuDays", {
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + CookieFunctions.getJWTToken()
            }
        })
            .then(res => res.ok ? res.json() : 0)
            .then(data => setLieuDays(data))
            .catch(() => setLieuDays(0));
    }

    useEffect(() => {
        if (type === "TOVAC") {
            fetchLieuDays();
        }
    }, [type]);

    return (
        <CCard className="mb-4">
            <CCardBody>
                <CCardTitle className='fs-2'>Submit A Request For Time Off</CCardTitle>
                <CCardSubtitle className=" mb-2 text-medium-emphasis">Requests will go to your dispatcher for approval. An email will be sent to you when your dispatcher updates the request.</CCardSubtitle>
                <hr />
                <CCol >
                    <CRow>
                        <CCol sm="12" className="my-2">
                            <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Select Time Off Type</CCardText>
                            <CFormSelect onChange={(e) => { setType(e.target.value) }}>
                                {Object.keys(timeOffNames[driverType][country]).map((x, i) => {
                                    return <option key={i} value={x}>{timeOffNames[driverType][country][x]}</option>
                                })}
                            </CFormSelect>
                            <CCardText>{type === 'VACPAYOUT' && <i>*You have selected Vacation Payout. You'll have to work during the vacation. </i>}</CCardText>
                        </CCol>
                        <CCol sm="6" className="my-2">
                            <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Start Date</CCardText>
                            {/* Start Date */}
                            <DatePicker
                                id='date-picker'
                                className='form-control'
                                value={startDate}
                                onChange={(date) => { setStartDate(date) }}
                                locale='en-ca'
                                format='yy-MM-dd'
                                minDetail='year'
                                yearPlaceholder='yyyy'
                                monthPlaceholder='mm'
                                dayPlaceholder='dd'
                                minDate={new Date(new Date().getFullYear(), 0, 1)}
                                maxDate={new Date(new Date().setMonth(new Date().getMonth() + 6))}
                            />
                        </CCol>
                        <CCol sm="6" className="my-2">
                            <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>End Date</CCardText>
                            {/* End Date */}
                            <DatePicker
                                id='date-picker'
                                className='form-control'
                                value={endDate}
                                onChange={(date) => { setEndDate(date) }}
                                locale='en-ca'
                                format='yy-MM-dd'
                                minDetail='year'
                                yearPlaceholder='yyyy'
                                monthPlaceholder='mm'
                                dayPlaceholder='dd'
                                minDate={startDate ? startDate : null}
                                maxDate={new Date(new Date().setMonth(new Date().getMonth() + 6))}
                            />
                        </CCol>
                        <CCol sm="3" className="my-2">
                            {/* Half Day */}
                            <CFormCheck className='fs-4' label="Half Day" checked={halfDay} onChange={(e) => { setHalfDay(e.target.checked) }} disabled={(startDate === null || endDate === null) ? false : startDate.toDateString() !== endDate.toDateString() || type === "TOSIC" || type === "TOPER"} />
                            <CCardText><i>*must be exactly 4 hours long</i> </CCardText>
                        </CCol>
                        {halfDay ?
                            <>
                                <CCol sm="3">
                                    <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Start Time</CCardText>
                                    <TimePicker
                                        id="startTime"
                                        showSecond={false}
                                        minuteStep={15}
                                        use12Hours={true}
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>End Time</CCardText>
                                    <TimePicker
                                        id="endTime"
                                        showSecond={false}
                                        minuteStep={15}
                                        use12Hours={true}
                                    />
                                </CCol>
                            </>
                            : <CCol sm="6" />}
                        {country === "CAN" &&
                            <CCol sm="12" className="my-2">
                                <CFormCheck className='fs-4' label="Include Weekends" checked={weekend} onChange={(e) => { setWeekend(e.target.checked) }} disabled={(type === "TOUNP") ? true : false} />
                            </CCol>
                        }
                        {country === "CAN" && type !== "TOUNP" &&
                            <>

                                <CCol sm="5" className="my-2">
                                    <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Please select your standard work week</CCardText>
                                    <CFormSelect value={workWeek} onChange={handleWorkWeek}>
                                        <option value="Monday - Friday">Monday - Friday</option>
                                        <option value="other">Other</option>
                                    </CFormSelect>
                                    {workWeek === 'other' && (
                                        <CFormInput
                                            placeholder="Please specify your work week"
                                            className="mt-2"
                                            value={other}
                                            onChange={(e) => { if (e.target.value.length <= 200) { setOther(e.target.value) } }}
                                        />
                                    )}
                                </CCol>
                            </>}
                        {country === "CAN" && type === "TOVAC" &&
                            <>

                                <CCol sm="10" className="my-2">
                                    <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Do you want to include vacation pay for the time-off requested if there is a balance available?</CCardText>
                                    <CFormSelect
                                        id="vacationPay"
                                        value={vacationPay}
                                        onChange={handleVacationPay}    >
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </CFormSelect>
                                </CCol>

                            </>}
                        {country === "USA" &&
                            <CCol sm="4" className="my-2">
                                <CCardText className='fs-4' style={{ marginBottom: '0px', marginTop: '8px' }}>Start Location of Vacation (optional) </CCardText>
                                <br />
                                <CFormInput className='fs-4' placeholder='Start Location' value={location} onChange={(e) => { if (e.target.value.length <= 100) { setLocation(e.target.value) } }} />
                            </CCol>
                        }
                        <CCol sm="12" className="my-2">
                            <CCardText className='fs-4' style={{ marginBottom: '0px', marginTop: '8px' }}>Comments (optional) </CCardText>
                            <CCardText><i>*maximum 200 characters</i> </CCardText>
                            {/* Comments */}
                            <CFormTextarea className='fs-4' placeholder='Comments' value={comments} onChange={(e) => { if (e.target.value.length <= 200) { setComments(e.target.value) } }} />
                        </CCol>
                        <CCol sm="12">
                            <CButton onClick={onSubmit} disabled={loading}>Submit</CButton>
                        </CCol>
                        {errors.length !== 0 ?
                            <CCol sm="12">
                                {errors.map((error, i) => {
                                    return <CCardText key={i} style={{ color: 'red', fontWeight: '600', fontSize: '20px' }}>{error}</CCardText>
                                })}
                            </CCol> : null}
                    </CRow>
                </CCol>
            </CCardBody>
            <CModal visible={confirmationModalVisible} alignment='center' onClose={() => setConfirmationModalVisible(false)}>
                <CModalHeader><CModalTitle>Time off Request Confirmation</CModalTitle></CModalHeader>
                <CModalBody>
                    <p>You are requesting more days than you have accrued. Do you still want to submit the time off request?</p>
                </CModalBody>
                <CModalFooter>
                    <CButton color="dark" variant='outline' onClick={() => setConfirmationModalVisible(false)}>No</CButton>
                    <CButton color="primary" onClick={() => { confirmRequest();}}>Yes</CButton>
                </CModalFooter>
            </CModal>
            <CModal visible={lieuModalVisible} alignment='center' onClose={() => setLieuModalVisible(false)} size="lg">
                <CModalHeader>
                    <CModalTitle>Time Off Request Guidelines</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <div>
                        <p>
                            You currently have <b>{lieuDays} in lieu day(s)</b> available. To request time off:
                        </p>
                        <ul>
                            <li>You must first submit each in lieu day individually under the Vacation Time Off Policy.</li>
                            <li>Any additional days beyond your in lieu days can be submitted together in a single request.</li>
                        </ul>
                        <p><b>Example:</b></p>
                        <p>John wants to take 5 days off and has <b>{lieuDays} in lieu days</b> available.</p>
                        <ul>
                            <li>Request 1 - Day 1 (In lieu day)</li>
                            <li>Request 2 - Day 2 (In lieu day)</li>
                            <li>Request 3 - Days 3 to 5 (Vacation or other leave type)</li>
                        </ul>
                    </div>
                </CModalBody>
                <CModalFooter>
                    <CButton color="primary" onClick={() => setLieuModalVisible(false)}>OK</CButton>
                </CModalFooter>
            </CModal>
        </CCard>
    )
}